
import { defineComponent, PropType } from 'vue'

import UILabel from '@/components/Common/UI2/Label/UILabel.vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import RoleAccessMixin from '~/mixins/roleAccessMixin'
import { RepoPerms, TeamPerms } from '~/types/permTypes'
import { KnowledgeScope, RenderedRow } from '~/utils/knowledge/types'

export default defineComponent({
  name: 'KnowledgeRow',
  components: {
    UILabel
  },
  mixins: [RoleAccessMixin, ActiveUserMixin],
  props: {
    row: {
      type: Object as PropType<RenderedRow>,
      required: true
    },
    scope: {
      type: String as PropType<KnowledgeScope>,
      default: KnowledgeScope.Repository
    },
    /** Team-admin gate for "Promote to team"; computed by the page (has team perms). */
    canPromote: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasTitle(): boolean {
      return Boolean(this.row.primary || this.row.title)
    },
    // Org pages list only promoted memories, so the badge is redundant there.
    showPromotedBadge(): boolean {
      return this.row.promotedToOwner && this.scope !== KnowledgeScope.Owner
    },
    canDelete(): boolean {
      if (this.scope === KnowledgeScope.Owner) {
        const teamRole = this.teamPerms?.permission
        return Boolean(teamRole) && this.$gateKeeper.team(TeamPerms.MANAGE_KNOWLEDGE, teamRole)
      }
      const role = this.repoPerms?.permission
      if (!role) return false
      return this.$gateKeeper.repo(RepoPerms.MANAGE_KNOWLEDGE, role)
    },
    showKebab(): boolean {
      return this.canDelete || this.canPromote
    }
  },
  methods: {
    onDelete(close: () => void): void {
      this.$emit('delete', { id: this.row.id })
      close()
    },
    onPromote(close: () => void): void {
      if (this.row.promotedToOwner) return
      this.$emit('promote', { id: this.row.id })
      close()
    },
    onDemote(close: () => void): void {
      if (!this.row.promotedToOwner || this.row.originRepoMissing) return
      this.$emit('demote', { id: this.row.id })
      close()
    }
  }
})
